export const CAUSE_NO_RECO = 'absence_recommandation';
export const CAUSE_PLAYER_TOO_SMALL = 'taille_player';
export const CAUSE_PLAYER_NO_FULLSCREEN = 'fullscreen_desactive';
export const CAUSE_USER_CLOSED = 'refus_recommandation';
